// BNB Address
//const BNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
const BNB_ADDRESS = '0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04'

export { BNB_ADDRESS }
